export default __webpack_public_path__ + "static/media/weather_app.ddb93f67.png";